import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import EmptyImage from 'assets/images/cloud-and-lock.webp';
import { useTranslation } from 'react-i18next';

import './WaitingRoomEmptyState.styles.scss';

type WaitingRoomEmptyStateProps = {
  className?: string;
};

const WaitingRoomEmptyState: React.FC<WaitingRoomEmptyStateProps> = (props) => {
  const { className } = props;

  const classes = classNames(
    'waiting-room-empty-state',
    'white-panel',
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyImage}
        asIllustration
        alt="Nothing to see here yet."
      />

      <p>{t('waitingRoomEmptyState')}</p>
      <p>{t('waitingRoomEmptyStateDescription')}</p>
    </div>
  );
};

export default WaitingRoomEmptyState;
